var map = {
	"./404.svg": 28527,
	"./bug.svg": 66518,
	"./chart.svg": 38691,
	"./clipboard.svg": 21450,
	"./component.svg": 80878,
	"./dashboard.svg": 92050,
	"./documentation.svg": 1913,
	"./drag.svg": 48076,
	"./edit.svg": 51045,
	"./education.svg": 18590,
	"./email.svg": 69233,
	"./example.svg": 77073,
	"./excel.svg": 44213,
	"./exit-fullscreen.svg": 89977,
	"./eye-open.svg": 40351,
	"./eye.svg": 79673,
	"./form.svg": 66792,
	"./fullscreen.svg": 60083,
	"./guide.svg": 10663,
	"./icon.svg": 36467,
	"./international.svg": 13576,
	"./language.svg": 62839,
	"./link.svg": 98846,
	"./list.svg": 82545,
	"./lock.svg": 50961,
	"./message.svg": 56590,
	"./money.svg": 10716,
	"./nested.svg": 6140,
	"./password.svg": 11568,
	"./pdf.svg": 88919,
	"./people.svg": 35865,
	"./peoples.svg": 89547,
	"./qq.svg": 34677,
	"./search.svg": 53498,
	"./shopping.svg": 1129,
	"./size.svg": 42099,
	"./skill.svg": 72665,
	"./star.svg": 8923,
	"./tab.svg": 45226,
	"./table.svg": 52704,
	"./theme.svg": 83008,
	"./tree-table.svg": 4150,
	"./tree.svg": 69514,
	"./user.svg": 69917,
	"./wechat.svg": 43168,
	"./zip.svg": 68940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42619;